/// <reference types="@types/googlemaps" />

export class MercatorProjection {
    constructor(public pixelOrigin: google.maps.Point,
        public pixelsPerLonDegree: number,
        public pixelsPerLonRadian: number
        ) { } 

    MERCATOR_RANGE = 256;

    bound(value, optMin?, optMax?) {
        if(optMin != null) value = Math.max(value,optMin);
        if(optMax != null) value = Math.min(value,optMax);
        return value;
    }

    degreesToRadians(deg): number {
        return deg * (Math.PI / 180);
    }

    radiansToDegrees(rad): number {
        return rad / (Math.PI / 180);
    }



    fromLatLngToPoint(latLng: any, optPoint: any): any {
        var me = this;
        var point = optPoint || new google.maps.Point(0,0);
        var origin = me.pixelOrigin;

        point.x = origin.x + latLng.lng() * me.pixelsPerLonDegree;

        var siny = this.bound(Math.sin(this.degreesToRadians(latLng.lat())),-0.9999,0.9999);
        point.y = origin.y + 0.5 * Math.log((1+siny) / (1 - siny)) * -me.pixelsPerLonRadian;
        return point;
    }

    fromPointToLatLng(point): google.maps.LatLng {
        var me = this;

        var origin = me.pixelOrigin;
        var lng = (point.x - origin.x) / me.pixelsPerLonDegree;
        var latRadians = (point.y - origin.x) / -me.pixelsPerLonRadian;
        var lat = this.radiansToDegrees( 2 * Math.atan(Math.exp(latRadians)) - Math.PI / 2);
        return new google.maps.LatLng(lat, lng);
    }

    topLeftCenter(zoom: any): google.maps.LatLng {
        return this.fromPointToLatLng(new google.maps.Point(this.MERCATOR_RANGE / Math.pow(2, zoom + 1), this.MERCATOR_RANGE / Math.pow(2, zoom + 1)));
    }

}
